import { Notifier } from "@airbrake/browser";
import { inferEnv } from "@glamcorner/core-cf-lib/lib/client/Hosting";

export const airbrake = new Notifier({
  // @ts-ignore: Defined by Webpack DefinePlugin
  projectId: AIRBRAKE_PROJECT_ID,
  // @ts-ignore: Defined by Webpack DefinePlugin
  projectKey: AIRBRAKE_PROJECT_KEY,

  environment: typeof window !== "undefined" ? inferEnv() : undefined,

  instrumentation: {
    onerror: false,
    fetch: false,
    history: false,
    console: false,
    xhr: false,
    // @ts-ignore: legit option that missing from types?
    // https://github.com/airbrake/airbrake-js/tree/master/packages/browser#unhandledrejection
    unhandledrejection: false,
  },
});

airbrake.addFilter((notice) => {
  // Bots usually block 3rd party requests and airbrake picks up when we cant fetch from 3rd party API
  if (/Googlebot|AdsBot-Google|Applebot|AhrefsBot/.test(notice.context?.userAgent)) {
    return null;
  }

  // Disable in these ENVs. For some reason `notice.environment` returns an empty object in dev
  if (["test", "development"].includes(notice.context?.environment)) {
    return null;
  } else {
    return notice;
  }
});
